import SectionCard from '../components/SectionCard';
import { recentOrders } from '../data/mockData';

function OrdersPage() {
  return (
    <div className="page-grid">
      <SectionCard title="Сводка выплат" subtitle="Контроль текущего статуса выплат партнерам">
        <div className="metrics-strip">
          <div>
            <span>Ожидают выплату</span>
            <strong>17</strong>
          </div>
          <div>
            <span>Готовы к выплате</span>
            <strong>24</strong>
          </div>
          <div>
            <span>Отклонены</span>
            <strong>3</strong>
          </div>
        </div>
      </SectionCard>

      <SectionCard title="Последние выплаты" subtitle="Просматривайте статусы и суммы выплат">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Партнер</th>
                <th>Сумма</th>
                <th>Статус</th>
                <th>Дата</th>
              </tr>
            </thead>
            <tbody>
              {recentOrders.map((order) => (
                <tr key={order.id}>
                  <td>{order.id}</td>
                  <td>{order.customer}</td>
                  <td>{order.amount}</td>
                  <td>{order.status}</td>
                  <td>{order.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SectionCard>
    </div>
  );
}

export default OrdersPage;